/** English copy for the feedback and what's new widgets. No em or en dashes in UI strings. */
export const MESSAGES = {
  errorGeneric: "Couldn't send feedback. Please try again.",
  errorNetwork: "Couldn't reach the feedback service. Please try again.",
  errorUnconfigured: 'Feedback is not available right now.',

  triggerLabel: 'Send feedback',
  title: 'Send feedback',
  about: 'About the billing dashboard',
  placeholder: "What's working, what isn't, what would help?",
  submit: 'Send feedback',
  cancel: 'Cancel',
  metaTitle: 'Sent with your feedback',
  screenshot: 'Screenshot',
  screenshotCapturing: 'Capturing...',
  screenshotUnavailable: 'Unavailable',
  includeScreenshot: 'Include screenshot',
  notIncluded: 'Not included',
  route: 'Route',
  signedInAs: 'Signed in as',
  sessionLength: 'Session length',
  consoleErrors: 'Console errors',
  includeConsole: 'Include console errors',
  privacy: 'Tokens, keys and authorization headers are stripped before anything leaves your browser.',
  verdictGood: 'Good change',
  verdictNeutral: 'Neutral, quality of life',
  verdictBad: 'Bad change',
  verdictChecking: 'Checking how this reads...',
  thanks: (key: string) => `Thanks, filed as ${key}. You'll get a reply on the ticket.`,
  thanksNoScreenshot: (key: string) => `Thanks, filed as ${key} (the screenshot didn't attach).`,
  consoleCaptured: (n: number) => `${n} captured`,

  updatesTitle: "What's new",
  updatesTrigger: "What's new",
  updatesTriggerUnread: (n: number) => `What's new (${n} unread)`,
} as const;
